<template>
  <div>
    <div class="stats-table table-responsive">
      <table class="table is-hoverable is-fullwidth">
        <thead>
          <tr>
            <th><abbr title="Data">Data</abbr></th>
            <th class="team-header"><abbr title="Time 1">Time 1</abbr></th>
            <th class="versus-header"><abbr title="">x</abbr></th>
            <th class="team-header"><abbr title="Time 2">Time 2</abbr></th>
            <th><abbr title="Mapa">Mapa</abbr></th>
            <th><abbr title="Lobby">Partida</abbr></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="lobby in lobbies" :key="lobby.id" :class="{ 'has-won': lobby.has_won, 'has-lose': lobby.has_won == false }">
            <td>{{ lobby.created_at_friendly }}</td>
            
            <td v-if="lobby.is_pug" :class="`team-column ${lobby.winner == 'team1' && lobby.team1_score >= 16 ? 'winner' : ''}`">
              <span class="team-score">{{ lobby.team1_score }}</span>
              {{ lobby.team1_name }}
            </td>
            <td v-if="lobby.is_pug" class="versus-column">
              <span v-if="lobby.status == 'match-ready'">live</span>
              x
            </td>
            <td v-if="lobby.is_pug" :class="`team-column ${lobby.winner == 'team2' && lobby.team2_score >= 16 ? 'winner' : ''}`">
              <span class="team-score">{{ lobby.team2_score }}</span>
              {{ lobby.team2_name }}
            </td>
            
            <td v-if="!lobby.is_pug" :class="`team-column ${lobby.winner == 'team1' && lobby.team1_score >= 16 ? 'winner' : ''}`">
              <span class="team-score">{{ lobby.team1_score }}</span>
              <router-link :to="{ name: 'TeamSingle', params: { id: lobby.team_a.id }}" v-if="lobby.team_a">
                  {{ lobby.team_a.name }}
                </router-link>
            </td>
            <td v-if="!lobby.is_pug" class="versus-column">
              <span v-if="lobby.status == 'match-ready'">live</span>
              x
            </td>
            <td v-if="!lobby.is_pug" :class="`team-column ${lobby.winner == 'team2' && lobby.team2_score >= 16 ? 'winner' : ''}`">
              <span class="team-score">{{ lobby.team2_score }}</span>
              <router-link :to="{ name: 'TeamSingle', params: { id: lobby.team_b.id }}" v-if="lobby.team_b">
                {{ lobby.team_b.name }}
              </router-link>
            </td>
            
            <td>
              {{ lobby.map }}
              <span class="lobby-size">{{lobby.players_per_team}}x{{lobby.players_per_team}}</span>
            </td>
            
            <td>
              <router-link :to="{ name: 'LobbySingle', params: { id: lobby.id }}">
                ver partida
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

export default {
  name: 'LobbiesTable',
  computed : {
  },
  props: {
    lobbies: Array
  },
  data () {
    return {
    }
  },
  methods: {
    initialize() {
    }
  },
  mounted () {
    this.initialize()
  },
  components: {
  }
}
</script>

<style scoped lang="sass">
.stats-table
  table
    td
      padding: 0.25em 0.45em
      font-size: 14px
  a
    color: #008EB4

  .versus-header
    text-align: center
  .versus-column
    text-align: center
    span
      display: block
      font-size: 12px
      background: green
      color: white
      padding: 3px 5px
      border-radius: 4px
  .team-header
    text-align: center
  .team-column
    text-align: center
    &.winner
      color: green
      font-weight: bold
  .team-score
    text-align: center
    display: block
  .lobby-size
    display: block

</style>
